var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"container"},[(_vm.label)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('change',$event.target.checked)}}}),_c('div',{class:{checkmark:true,marked:_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }